//* Components
import Text from '@/components/common/Text';
import Editor from '@/components/common/Editor';
import CustomImage from '@/components/common/Image';
import CustomRate from '@/components/common/CustomRate';

//* Style
import ReviewItemStyle from './style';

const ReviewItem = ({ author, content, date, rating }) => {
    return (
        <ReviewItemStyle>
            <div className={`comment`}>
                <div className='comment-top'>
                    <CustomImage
                        className={'comment-image'}
                        src={'/images/comment-smile.png'}
                    />

                    <Text
                        className={'h4 font-futura-medium full-name'}
                        text={author}
                    />

                    <Text
                        className={'h5 font-futura-regular grey'}
                        text={date}
                    />
                </div>

                {rating ? (
                    <CustomRate
                        hasLabel={false}
                        defaultValue={rating}
                        className={'comment-rate'}
                    />

                ) : null}

                <Editor data={content} />
            </div>
        </ReviewItemStyle>
    );
};

export default ReviewItem;
